//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
let d=[[[0,"Aperture",1,0],[0,"BreadthPercentile",1,0],[0,"BreadthValue",1,0],[0,"Database",1,0],[0,"Gender",1,0],[0,"GloveThickness",1,0],[0,"IncludeForearm",1,0],[0,"LengthPercentile",1,0],[0,"LengthValue",1,0],[0,"ShapeName",1,0],[0,"Side",1,0],[0,"Style",1,0]],[[[],"UpdateHandPropsButton",{},0,0],[[],"JointDialogButton",{},0,0],[["humanfeaturebuilder"],"SetHumanFeatureBuilder",{},1,0]],[]];
SPLM.HumanHandsDialogBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.HumanHandsDialogBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.HumanHandsDialogBuilder.GenderType = Object.freeze({
    "Male" : "Male", "Female" : "Female"});

SPLM.HumanHandsDialogBuilder.HandType = Object.freeze({
    "Right" : "Right", "Left" : "Left"});

SPLM.HumanHandsDialogBuilder.StyleType = Object.freeze({
    "Gloves" : "Gloves", "BareHands" : "BareHands"});

SPLM.HumanHandsDialogBuilder.DatabaseType = Object.freeze({
    "Ansur" : "Ansur", "Ansur2" : "Ansur2", "Nhanes" : "Nhanes", "Nhanes2014" : "Nhanes2014"});

SPLM.HumanHandsDialogBuilder.LengthType = Object.freeze({
    "P5" : "P5", "P25" : "P25", "P50" : "P50", "P75" : "P75", "P95" : "P95"});

SPLM.HumanHandsDialogBuilder.BreadthType = Object.freeze({
    "P5" : "P5", "P25" : "P25", "P50" : "P50", "P75" : "P75", "P95" : "P95"});

export default SPLM;